import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FormControl} from 'react-bootstrap';

import actions from './../../actions';
import {entityFetcher} from './../../utils/entityFetcher';
import Loading from './../../components/loading';
import {getMessage} from './../../utils/i18n';
import ldapFields from './ldapFields';
import './myProfile.css';
import { postLogout } from '../../utils/postLoginLogout';

class MyProfile extends Component {

    constructor(props) {
        super(props);
        this.pendingRequests = {};
        this.state = {
            loading: false,
            profile: {}
        }
        this.registerRequest = this.registerRequest.bind(this);
        this.getReturnURL = this.getReturnURL.bind(this);
        this.isSAMLType = this.isSAMLType.bind(this);
    };

    getUserEntity() {
        this.setLoadingState(true);
        const requestToken = new Date().getTime();
        return entityFetcher.read({
            api: `fo/me/profile`,
            cancelToken: this.registerRequest(requestToken),
            params: {timestamp: requestToken}
        }).then(json => {
            delete this.pendingRequests[requestToken];
            return json;
        }, e => {
            delete this.pendingRequests[requestToken];
            return Promise.reject(e);
        });
    };

    setLoadingState(isLoading) {
        this.setState({
            loading: !!isLoading,
        })
    }

    registerRequest(token) {
        token = token ? token : new Date().getTime();
        return (cancelFunc) => {
            Object.assign(this.pendingRequests, {[token]: cancelFunc});
        };
    };

    componentDidMount() {
        this.getUserEntity().then(profile => {
            this.setState({
                loading: false,
                profile,
            })
        }).catch(() => {
            this.setLoadingState(false);
        });
    }

    componentWillUnmount() {
        Object.keys(this.pendingRequests).forEach((token) => {
            this.pendingRequests[token]();
            delete this.pendingRequests[token];
        });
    };

    constructFields() {
        const {profile} = this.state;
        if (Object.keys(profile).length === 0) {
            return ;
        }

        return Object.keys(ldapFields).map((field, index) => {
            const {displayLabelKey, validator, required} = ldapFields[field];
            const label = getMessage(displayLabelKey);
            const value = profile[field];
            const errorMsg = typeof validator === 'function' && validator(value, profile);
            return (
                <div className="foColField" key={field}>
                        <label className="foColFieldLabel" title={label}>
                            {!!required && <span className="foColFieldIsRequired">{"*"}</span>}
                            {label + ": "}
                        </label>
                    <div className="foColFieldInputWrapper">
                        <FormControl readOnly={true} value={value || ''} className="foColFieldInput"/>
                        { errorMsg && <span className="foColFieldErrorMsg">{getMessage(errorMsg)}</span>}
                    </div>
                </div>
            )
        })
    }

    getReturnURL() {
        const matchAccountParam = this.props.location.search.match(/ACCOUNTID=(\d)+/g);
        const matchIdpServerType = this.props.location.search.match(/(LDAP=\d+)|(SAML=\d+)/g);
        if (matchAccountParam && matchIdpServerType) {
            const matchAccountId = matchAccountParam[0].replace(`ACCOUNTID=`,'').trim();
            const accountIdpInfo = matchIdpServerType[0].split('=');
            const idpServerType = accountIdpInfo[0].toLowerCase();
            const accountIdpId = accountIdpInfo[1];

            return `/bo/accounts/${matchAccountId}/authentication/${idpServerType}/${accountIdpId}/general`
        }

        return `/bo/accounts`;
    }

    isSAMLType(authType) {
        if (authType && authType === 'FEDERATION') {
            return true;
        }

        if (authType && authType === 'MIX') {
            const matchIdpServerType = this.props.location.search.match(/(LDAP=\d+)|(SAML=\d+)/g);
            if (matchIdpServerType && matchIdpServerType[0]) {
                const accountIdpInfo = matchIdpServerType[0].split('=');
                const idpServerType = accountIdpInfo[0].toLowerCase();
                if (idpServerType === 'saml') {
                    return true;
                }
            }
        }
        return false;
    }

    handleLogout(e) {
        const requestToken = new Date().getTime();
        const returnUrl = this.getReturnURL();
        const {authenticationType} = this.state.profile;

        if (this.isSAMLType(authenticationType)) {
            postLogout();
            return ;
        }

        return entityFetcher.read({
            fullUrl: `/bo/boLogout`,
            cancelToken: this.registerRequest(requestToken),
            params: {timestamp: requestToken}
        }).then(json => {
            delete this.pendingRequests[requestToken];
            window.location.assign(window.location.origin + returnUrl);
            return json;
        }, e => {
            delete this.pendingRequests[requestToken];
            return Promise.reject(e);
        });
    }

    render() {
        const {loading, profile} = this.state;
        const {authenticationType} = profile;
        let formBody = !!loading ? <Loading /> : this.constructFields();
        const getBtnText = (this.isSAMLType(authenticationType)) ? getMessage("app.action.logout") : getMessage("app.action.logoutToSysBo");
        return (
                <div className="foSuiteModuleWrapper">
                    <span className="foSuiteModuleTitle">{getMessage("module.userProfile")}</span>
                    <div className="foLdapUserProfile">
                        {formBody}
                        <div className="foLdapUserProfileButtonWrapper">
                        <button className="foLdapUserProfileLogoutButton" onClick={this.handleLogout.bind(this)}>
                            {getBtnText}
                        </button>
                        </div>
                        <div className="foLdapUserProfileNoteMsg"> {getMessage("user-profile.note-message")} </div>
                    </div>
                </div>
        );
    };

}

export default connect(null, {
    initialize: actions.initialize,
})(MyProfile);


// WEBPACK FOOTER //
// ./src/app/containers/myProfile/index.js